import React, { Component } from 'react';
import { match, Route, Switch } from 'react-router-dom';
import { Location } from 'history';
import { Link } from '~/UI/Button';

import styles from './styles.less';

export const isNavigationItemActive = (location: Location, match: match<any> | null, anchor: string) =>
	match !== null && location.hash === anchor;

interface Props {
	to: string;
	activePaths: string[];
	children: React.ReactNode;
	isActive: (LocationShape: Location, Match: match<any> | null, string: string) => boolean;
}

export default class NavigationItem extends Component<Props> {
	static defaultProps = {
		activePaths: [],
		isActive: isNavigationItemActive,
	};

	render() {
		const { to, activePaths, children, isActive } = this.props;

		return (
			<Switch>
				{[to, ...activePaths].map((path) => {
					let anchor = '';
					const toWithoutAnchor = path.replace(/#.*$/, (match) => {
						anchor = match;
						return '';
					});

					return (
						<Route exact key={path} path={toWithoutAnchor}>
							{({ location, match }: never) => {
								const isItemActive = isActive(location, match, anchor);
								return (
									<li className={styles.navigationListItem}>
										<Link
											className={isItemActive ? styles.navigationLinkActive : styles.navigationLink}
											data-testid={isItemActive ? 'navigation-active-item' : null}
											to={to}
										>
											{children}
										</Link>
									</li>
								);
							}}
						</Route>
					);
				})}

				<Route>
					<li className={styles.navigationListItem}>
						<Link className={styles.navigationLink} to={to}>
							{children}
						</Link>
					</li>
				</Route>
			</Switch>
		);
	}
}
